import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  navigate(event) {
    const row = event.target.closest("tr[data-href]")
    if (!row) return

    if (
      event.target.closest("a") ||
      event.target.closest("button")
    ) {
      return
    }

    const href = row.dataset.href
    if (href) {
      window.location.href = href
    }
  }
}
